export class DateTimeUtil {

  static compareDates(a: Date | null, b: Date | null, descending = false) {

    if(a == null && b == null) {
      return 0;
    }

    if (a == null) {
      return -1;
    }

    if (b == null) {
      return 1;
    }

    return  descending ? (a > b ? -1 : 1) : (a > b ? 1 : -1);
  }


  static isAtLeast18(dateOfBirth: Date) {
    const today = new Date();
    const birthDate = new Date(dateOfBirth);

    // Calculate the difference in years
    let age = today.getFullYear() - birthDate.getFullYear();

    // Check if birthday hasn't occurred this year yet
    const monthDiff = today.getMonth() - birthDate.getMonth();
    const dayDiff = today.getDate() - birthDate.getDate();

    if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
      age--;
    }

    return age >= 18;
  }
}
